import { render } from "./SidebarComponent.vue?vue&type=template&id=32d4579d&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=32d4579d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d4579d"]])

export default __exports__